import {NgClass} from "@angular/common";
import {Component, EventEmitter, Input, Output} from '@angular/core';

import {StepperItem} from "./models/stepper-item";

@Component({
  selector: 'nz-stepper',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss'
})
export class StepperComponent {
  @Input() steps!: StepperItem[];
  @Input() selectedStep!: number;
  @Output() onSelectStep = new EventEmitter<number>();
}
